import { Component, OnInit } from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {RacerService} from '../shared/services/databaseServices/racer/racer.service';
import {EditService} from '../shared/services/editService/edit.service';
import {Racer} from '../racer-tab/Racer';
import {faMoneyCheckAlt} from '@fortawesome/free-solid-svg-icons/faMoneyCheckAlt';
import {Category} from '../shared/classes/Category';
import {RacesService} from '../shared/services/databaseServices/races/races.service';
import {TypeOfPayService} from '../shared/services/databaseServices/typeOfPay/type-of-pay.service';
import {BaseDatabaseService} from '../shared/services/databaseServices/BaseDatabaseService';
import {DialogComponent} from '../dialog/dialog.component';
import {MatDialog, MatSnackBar} from '@angular/material';
import {TranslatePipe} from '../translate.pipe';
import {LocalStorageService} from '../shared/services/localStorageService/local-storage.service';
import {EmailTable} from '../shared/classes/EmailTable';
import {EmailTableService} from '../shared/services/databaseServices/emailTable/email-table.service';
import {EmailService} from '../shared/services/emailService/email.service';
import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {Track} from '../shared/classes/Track';

@Component({
  selector: 'app-racer-pay-detail',
  templateUrl: './racer-pay-detail.component.html',
  styleUrls: ['./racer-pay-detail.component.css'],
  providers: [TranslatePipe]
})
export class RacerPayDetailComponent implements OnInit {

  isNew = false;
  plusButton = false;
  editButton = true;

  faMoneyCheck = faMoneyCheckAlt;

  createTooltip = 'raceDetailPage.startFeeTab.saveToolTip';
  deleteTooltip = 'raceDetailPage.startFeeTab.deleteToolTip';
  addTooltip = 'raceDetailPage.startFeeTab.addToolTip';

  racerForm = this.formBuilder.group({
    name: ['', []],
    surname: ['', []],
    year: ['', []],
    sex: ['', []],
    category: ['', []],
    email: ['', [Validators.email]],
    mobile: ['', []],
    club: ['', []],
    city: ['', []],
    team: ['', []],
    familyTandem: ['', []],
    voucher: ['', []],
    note: ['', []],
    gdpr: ['', []],
    timeOfReg: ['', []],
    startFee: ['', []],
    timeOfPay: ['', []],
    paid: ['', []],
    typeOfPay: ['', []],
    vs: ['', []],
    track: ['', []],
    lunch: ['', []],
    gdrp: ['', []],
    newsletter: ['', []]
  });

  racer: Racer;
  categories: Category[] = [];
  filteredTrack: Track[] = [];
  sexes = ['Muž', 'Žena'];
  lunches = ['MASOVÉ nepálivé bezlepkové RED KARI s rýží', 'VEGAN nepálivé bezlepkové RED KARI s rýží']
  typeOfPay = undefined;
  raceId;

  constructor(private formBuilder: FormBuilder,
              private editService: EditService,
              public snackBar: MatSnackBar,
              public router: Router,
              public emailTableService: EmailTableService,
              public emailService: EmailService,
              public localStoreService: LocalStorageService,
              public translatePipe: TranslatePipe,
              public datePipe: DatePipe,
              public dialog: MatDialog,
              private typeOfPayService: TypeOfPayService,
              private racesService: RacesService,
              private racerService: RacerService) { }

  ngOnInit() {
    if (this.racerService.racer === undefined) {
      const racerId = this.localStoreService.read('racerId');
      const raceId = this.localStoreService.read('raceId');
      this.racerService.getOneRacer(racerId).then(data => {
        this.racer = data.data();
        this.racer.key = racerId;
        this.racesService.getOne(raceId).then(raceData => {
          this.racesService.race = raceData.data();
          this.racesService.race.id = raceId;
          this.categories = this.racesService.race.categories;
          this.filteredTrack = this.racesService.race.track;
          this.loadForm();
          this.loadTypeOfPay();
        });
      });
    } else {
      this.racer = this.racerService.racer;
      this.categories = this.racesService.race.categories;
      this.filteredTrack = this.racesService.race.track;
      this.loadForm();
      this.loadTypeOfPay();
    }
  }

  loadForm() {
    this.racerForm.patchValue({
      name: this.racer.name,
      surname: this.racer.surname,
      year: this.racer.year,
      sex: this.racer.sex,
      category: this.racer.category,
      email: this.racer.email,
      mobile: this.racer.mobile,
      club: this.racer.club,
      city: this.racer.city,
      voucher: this.racer.voucher,
      note: this.racer.note,
      gdpr: this.racer.gdpr,
      track: this.racer.track,
      team: this.racer.team,
      familyTandem: this.racer.familyTandem,
      // @ts-ignore
      timeOfReg: this.datePipe.transform(new Date(this.racer.timeOfReg.seconds * 1000), 'dd.MM.y hh:mm:ss') ,
      startFee: this.racer.startFee,
      // @ts-ignore
      timeOfPay: this.racer.timeOfPay === -1 ? '-1' : this.datePipe.transform(new Date(this.racer.timeOfPay.seconds * 1000), 'dd.MM.y hh:mm:ss') ,
      paid: this.racer.paid,
      typeOfPay: this.racer.pay,
      vs: this.racer.vs,
      lunch: this.racer.lunch,
      newsletter: this.racer.newsletter
    });
  }

  loadTypeOfPay() {
    this.typeOfPayService.getAll().then(data => {
      this.typeOfPay = BaseDatabaseService.toArray(data);
    });
  }

  save(item) {
    this.loadFromForm();
    this.racerService.update(this.racer).then(() => {
      this.openSnack(this.translatePipe.transform('racesPage.racers.snack.user.success'),  this.translatePipe.transform('racesPage.racers.snack.action')  , 5000);
    }).catch( err => {
      console.error(err);
      this.openSnack(this.translatePipe.transform('racesPage.racers.snack.user.failed'),  this.translatePipe.transform('racesPage.racers.snack.action')  , 15000);
    });
  }

  private loadFromForm() {

    this.racer.key = this.racer.key === undefined ? this.racerService.racer.id : this.racer.key;
    this.racer.id = this.racer.key;
    this.racer.name = this.racerForm.getRawValue().name;
    this.racer.surname = this.racerForm.getRawValue().surname;
    this.racer.year = this.racerForm.getRawValue().year;
    this.racer.sex = this.racerForm.getRawValue().sex;
    this.racer.category = this.racerForm.getRawValue().category;
    this.racer.email = this.racerForm.getRawValue().email;
    this.racer.mobile = this.racerForm.getRawValue().mobile;
    this.racer.club = this.racerForm.getRawValue().club;
    this.racer.voucher = this.racerForm.getRawValue().voucher;
    this.racer.city = this.racerForm.getRawValue().city;
    this.racer.note = this.racerForm.getRawValue().note;
    this.racer.gdpr = this.racerForm.getRawValue().gdpr === undefined ? false: this.racerForm.getRawValue().gdpr;
    this.racer.timeOfReg = this.racer.timeOfReg;
    this.racer.startFee = this.racerForm.getRawValue().startFee;
    this.racer.timeOfPay = this.racer.timeOfPay;
    this.racer.paid = this.racerForm.getRawValue().paid;
    this.racer.pay = this.racerForm.getRawValue().typeOfPay;
    this.racer.vs = this.racerForm.getRawValue().vs;
    this.racer.lunch = this.racerForm.getRawValue().lunch
    this.racer.newsletter = this.racerForm.getRawValue().newsletter
  }

  transformDate(date){
    const d = date.split('.');
    const t = d[2].split(' ');

    const ret = `${t[0]}.${d[1]}.${d[0]} ${t[1]}`;
    return ret;
  }

  delete(item) {
    const id = this.racer.key === undefined ? this.racer.id : this.racer.key;
    this.racerService.delete(id).then(() => {
      this.router.navigate(['/admin/races/allRacers/', this.racesService.race.id  ]);
    });
  }

  add(item) {

  }

  paid() {
    this.racer.paid = !this.racer.paid;
    this.openSnack(this.translatePipe.transform('racesPage.racers.snack.message'),  this.translatePipe.transform('racesPage.racers.snack.action')  , 5000);
    if (this.racer.paid) {
      this.sendEmailDb(this.racer);
      this.racer.timeOfPay = new Date();
      this.racerForm.patchValue({timeOfPay: this.datePipe.transform(this.racer.timeOfPay.getTime(), 'dd.MM.yy hh:mm:ss') });
    } else {
      this.racer.timeOfPay = -1;
      this.racerForm.patchValue({timeOfPay: '-1'});
    }
    this.racerService.update(this.racer);
  }

  isEdit() {
    return this.editService.editable;
  }

  private openSnack(message, action, time) {
    const snack = this.snackBar.open(message, action, {
      duration: time,
    });
    snack.onAction().subscribe(() => {
    });
  }

  private sendEmailDb(racer: Racer) {
    this.emailTableService.getOne(this.racesService.raceId).then(data => {
      const toEmail = racer.email;

      const email: EmailTable = data.data().emails.filter(i => i.messageType.toLowerCase() === EmailTable.ON_PAY.toLowerCase())[0];

      let message = email.onPayMessage;
      message = message.replace(EmailTable.key_name, racer.name);
      message = message.replace(EmailTable.key_surname, racer.surname);
      message = message.replace(EmailTable.key_varSym, racer.vs);

      this.emailService.sendEmail(email.onPayFrom, toEmail, email.onPaySubject, message);
    });
  }

  private openDialog(header, text, button, info, danger) {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '250px',
      data: {
        header,
        text,
        actionButton: button,
        info,
        danger
      }
    });
    return dialogRef;
  }

}
